"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadLangSetting = exports.saveLangSetting = void 0;
var saveLangSetting = function (window, lang, key) {
    try {
        window.localStorage && window.localStorage.setItem(key, lang);
    }
    catch (err) {
        console.error(err);
    }
};
exports.saveLangSetting = saveLangSetting;
var detectBrowserLanguage = function (navigator) {
    return ((navigator.languages && navigator.languages[0]) ||
        navigator.language ||
        navigator.userLanguage ||
        navigator.browserLanguage);
};
var loadLangSetting = function (window, langs, key) {
    var loadedLang = '';
    try {
        loadedLang =
            (window.localStorage && window.localStorage.getItem(key)) ||
                detectBrowserLanguage(window.navigator);
    }
    catch (err) {
        console.error(err);
    }
    return langs.includes(loadedLang) && loadedLang;
};
exports.loadLangSetting = loadLangSetting;
